import { X, ExternalLink } from 'lucide-react';
import type { OAuthConnection } from '../lib/api';
import { Button } from './ui';

interface ConnectionModalProps {
  connection: OAuthConnection;
  onClose: () => void;
}

export default function ConnectionModal({ connection, onClose }: ConnectionModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="ds-card w-full max-w-2xl shadow-card animate-fade">
        <div className="flex items-center justify-between p-6 border-b border-line">
          <h3 className="font-display text-xl font-semibold text-ink">Connection Details</h3>
          <button
            onClick={onClose}
            className="text-ink-3 hover:text-ink transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          <div className="space-y-6">
            <div>
              <h4 className="text-sm font-medium text-ink-3 mb-1">Workspace Details</h4>
              <p className="text-base text-ink mb-1">{connection.workspaceName}</p>
              <p className="text-sm text-ink-2">
                Workspace ID:{' '}
                <span className="font-mono bg-surface-2 px-2 py-0.5 rounded">
                  {connection.workspaceId}
                </span>
              </p>
            </div>

            <div>
              <h4 className="text-sm font-medium text-ink-3 mb-1">Team Details</h4>
              <p className="text-base text-ink mb-1">{connection.teamName}</p>
              <p className="text-sm text-ink-2">
                Team ID:{' '}
                <span className="font-mono bg-surface-2 px-2 py-0.5 rounded">
                  {connection.teamId}
                </span>
              </p>
            </div>

            <div>
              <h4 className="text-sm font-medium text-ink-3 mb-1">Workspace URL</h4>
              {connection.workspaceUrl && (
                <a
                  href={connection.workspaceUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base text-accent-ink hover:underline flex items-center"
                >
                  {connection.workspaceUrl}
                  <ExternalLink className="w-4 h-4 ml-1" />
                </a>
              )}
            </div>

            <div>
              <h4 className="text-sm font-medium text-ink-3 mb-1">Connected</h4>
              <p className="text-base text-ink">
                {new Date(connection.createdAt).toLocaleDateString(undefined, {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-surface-2 px-6 py-4 rounded-b-[15px] flex justify-end">
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
